package meineglasfaser.frontend.common.components.widgets

import androidx.compose.runtime.Composable
import meineglasfaser.frontend.common.components.yaform.YaFormProperty
import meineglasfaser.frontend.common.components.yaform.YaFormScope
import meineglasfaser.frontend.common.components.yaform.YaFormTextInput
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

@Composable
fun <T : Any> YaFormScope<T>.UBLPostalAddressInputs(
    streetName: YaFormProperty<T>,
    cityName: YaFormProperty<T>,
    postalZone: YaFormProperty<T>,
    countryCode: YaFormProperty<T>,
) {
    YaFormTextInput(
        prop = streetName,
        label = { Text("Straße") },
        type = InputType.Text,
        required = true,
    )
    Div({ classes("grid") }) {
        YaFormTextInput(
            prop = postalZone,
            label = { Text("PLZ") },
            type = InputType.Text,
            pattern = "[0-9]{4}",
            required = true,
        )
        YaFormTextInput(
            prop = cityName,
            label = { Text("Stadt") },
            type = InputType.Text,
            required = true,
        )
    }
    YaFormTextInput(
        prop = countryCode,
        label = { Text("Land") },
        type = InputType.Text,
        placeholder = "AT", // TODO: country selector
        required = true,
        disabled = true,
    )
}
